/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { defaultLocale } from "../datetime/constants";

import { NumberFormatOptions } from "./NumberFormatOptions";

/**
 * Formats given number to a local number using the provided options.
 * @example "1,110"
 * @param value The number to format.
 * @param options The options for formatting the number.
 * @returns The formatted local number.
 */
export const toLocalNumber = (value: number, options?: NumberFormatOptions): string => {
    const { format, locale } = options ?? {};

    return Intl.NumberFormat(locale ? locale : defaultLocale, format).format(value);
};
